(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hac-campus-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hac-campus-gallery')) {
  customElements.define('hac-campus-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track=this.querySelector('.hac-campus-track'), slides=[...this.querySelectorAll('figure')], dots=[...this.querySelectorAll('[data-slide]')], pause=this.querySelector('[data-pause-button]');
      if (!track || slides.length<2) return;
      this.querySelector('.hac-campus-controls').hidden=false;
      const controller=new AbortController(), signal=controller.signal, reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let index=0, manualPause=reduced.matches, hover=false, focused=false, dragging=false, visible=false, timer, raf;
      const stop=()=>clearInterval(timer);
      const loadSlide=(i)=>{
        const slide=slides[i],template=slide?.querySelector('template[data-campus-image]');
        if(!template)return;
        slide.querySelector('.hac-campus-placeholder').replaceWith(template.content.cloneNode(true));
        template.remove();
      };
      const prepare=(i)=>{loadSlide(i);if(i+1<slides.length)loadSlide(i+1);};
      const sync=()=>{index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===index)));if(visible)prepare(index);};
      const go=(i)=>{const target=(i+slides.length)%slides.length;for(let n=Math.min(index,target);n<=Math.max(index,target);n++)loadSlide(n);index=target;prepare(index);track.scrollTo({left:index*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});};
      const schedule=()=>{stop();if(!manualPause&&!hover&&!focused&&!dragging&&visible&&!document.hidden&&!reduced.matches)timer=setInterval(()=>go(index+1),5000);};
      const label=()=>{pause.setAttribute('aria-label',manualPause?this.dataset.play:this.dataset.pause);pause.firstElementChild.textContent=manualPause?'▶':'Ⅱ';};
      // Manual navigation restarts the interval; only the pause button stops autoplay persistently.
      const interact=()=>{stop();};
      const on=(el,event,fn)=>el.addEventListener(event,fn,{signal});
      on(this.querySelector('[data-prev]'),'click',()=>{interact();go(index-1);schedule();});
      on(this.querySelector('[data-next]'),'click',()=>{interact();go(index+1);schedule();});
      dots.forEach((d,i)=>on(d,'click',()=>{interact();go(i);schedule();}));
      on(pause,'click',()=>{manualPause=!manualPause;label();schedule();});
      on(track,'pointerdown',()=>{dragging=true;interact();loadSlide(index-1);prepare(index);});
      const release=()=>{if(dragging){dragging=false;schedule();}};
      on(document,'pointerup',release);
      on(document,'pointercancel',release);
      on(track,'scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(sync);});
      on(this,'pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;schedule();}});
      on(this,'pointerleave',()=>{hover=false;schedule();});
      on(this,'focusin',e=>{focused=e.target.matches(':focus-visible');schedule();});
      on(this,'focusout',e=>{if(!this.contains(e.relatedTarget)){focused=false;schedule();}});
      on(this,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();interact();go(index+(e.key==='ArrowRight'?1:-1));}});
      on(document,'visibilitychange',schedule);
      on(reduced,'change',()=>{manualPause=reduced.matches;label();schedule();});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)prepare(index);schedule();},{threshold:.25});observer.observe(this);
      const resize=new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'instant'}));resize.observe(track);
      this.cleanup=()=>{stop();cancelAnimationFrame(raf);controller.abort();observer.disconnect();resize.disconnect();};
      label();sync();schedule();
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hac-hotel-welcome"]) return;
  try {
    
(function () {
  function showHotel() {
    document.querySelectorAll('[data-hac-hotel-welcome]').forEach(function (root) {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      var handle = new URLSearchParams(location.search).get('hotel');
      var aliases = {'four-seasons-guangzhou':'guangzhou-four-seasons','westin-pazhou':'guangzhou-westin-pazhou'};
      handle = aliases[handle] || handle;
      var templates = Array.from(root.querySelectorAll('[data-hac-hotel-template]'));
      var selected = templates.find(function (item) { return item.dataset.hotelHandle === handle; });
      if (!selected) { root.querySelector('[data-hac-hotel-invalid]').hidden = false; templates.forEach(function (item) { item.remove(); }); return; }
      var isChinese = document.documentElement.lang.toLowerCase().indexOf('zh') === 0;
      root.querySelector('[data-hac-welcome-title]').textContent = isChinese ? selected.dataset.nameZh : selected.dataset.nameEn;
      root.querySelector('[data-hac-welcome-copy]').textContent = isChinese ? selected.dataset.welcomeZh : selected.dataset.welcomeEn;
      root.querySelector('[data-hac-hotel-display]').appendChild(selected.content.cloneNode(true));
      templates.forEach(function (item) { item.remove(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showHotel);
  else showHotel();
  document.addEventListener('shopify:section:load', showHotel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
